import axios from "axios";
import { isPublicRoute } from "../utils/authUtils"; // Helper per rotte pubbliche

// Usa una variabile d'ambiente per il base URL, con un fallback per lo sviluppo
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // Importante se usi sessioni basate su cookie
});

// Interceptor per aggiungere il token Bearer alle richieste
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Interceptor per gestire risposte 401 (Unauthorized / Session Expired)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Controlla se non siamo già su una rotta pubblica (es. /login)
      if (!isPublicRoute(window.location.pathname)) {
        console.warn("Session expired or unauthorized. Redirecting to login.");
        localStorage.removeItem("authToken");
        // Dispatch un evento custom per notificare l'AuthContext
        window.dispatchEvent(new CustomEvent("sessionExpired"));
        // Potresti voler reindirizzare qui, ma è meglio gestirlo nell'AuthContext
        // window.location.href = '/login'; // Evita se possibile, usa useNavigate
      }
    }
    return Promise.reject(error);
  }
);

export default api;